import React from 'react';
import ReactDOM from 'react-dom/client';
import { initRum } from './monitoring/rum';
import App from './App';

// Initialize CloudWatch RUM before rendering — captures page load metrics
initRum();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
